export const CLICK_THANK_YOU_BUTTON = 'CLICK_THANK_YOU_BUTTON';